import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import NProgress from 'nprogress'

import Grid from './Grid';
import Train from '../services/train.js';

import '../../css/SearchResult.css';


class SearchResult extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
    }

    this.lastQuery = undefined;

  }

  componentDidMount() {
    this.search(this.props.match.params.query);
  }

  componentWillReceiveProps(newProps) {
    this.search(newProps.match.params.query);
  }

  search(query) {

    this.lastQuery = query;
    this.setState({searchResults: undefined});

    if (query && query.trim().length > 0) {

      NProgress.start();

      Train.fetchSearchResults({
        query
      }).then((results) => {
        if (this.lastQuery === query) {
          this.setState({searchResults: results});
          NProgress.done();
        }
      }).catch((e) => {
        NProgress.done();
        Notification.show('Error loading search results', 'error');
      });
    } 
  }

  noResultsFound(results) {

    if (!results)
      return false;

    let empty = Object.keys(results)
    .map((key) => {
      return results[key].length === 0;
    })
    .reduce((a,b) => {
      return a && b;
    });

    return empty;

  }

  render() {

    if (!this.state.searchResults)
      return null;

    let results = this.state.searchResults;

    if (this.noResultsFound(results)) {
      return (
        <div className="noResultsFound">
          <h1>Unfortunately no results were found. Please refine your search.</h1>
        </div>
      );
    }

    return (
      <div className="searchResults"> 
        <Grid title="Artists" elements={results.artists} type="artist" playable={true} max={8}/>
        <Grid title="Albums" elements={results.albums} type="album" playable={true} max={8}/>
        <Grid title="Tracks" elements={results.tracks} type="track" playable={true} max={8}/>
        <Grid title="Tags" elements={results.tags} type="tag" playable={true} max={8}/>
        <Grid title="Users" elements={results.users} type="user" playable={true} max={8}/>
        <Grid title="Last.fm users" elements={results.lastfmUsers} type="lastfm_user" playable={true} max={8}/>
      </div>
    );
  }
}

export default withRouter(SearchResult);



// WEBPACK FOOTER //
// ./src/js/components/SearchResult.jsx